<template>
    <div class="mx-auto flex max-w-4xl flex-col-reverse items-center justify-center gap-16 text-center md:flex-row md:text-start">
        <NuxtImg :src="imageUrl"
                 alt=""
                 height="261"
                 width="261"
                 class="max-h-56 md:max-h-fit"
        />

        <div>
            <h2 class="sim-h4 mb-6">
                {{ title }}
            </h2>

            <p v-if="subtitle" class="sim-error-text mb-7">
                {{ subtitle }}
            </p>

            <MainSearchComponent
                v-if="showSearch"
                size="normal"
                :color="color"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
import type { BaseUiInputColors } from './base/BaseUiInput.vue'

const {
    imageUrl,
    title,
    subtitle,
    color = 'white',
    showSearch = true,
} = defineProps<{
    imageUrl: string
    title: string
    subtitle?: string
    color?: BaseUiInputColors
    showSearch?: boolean
}>()

</script>

<style lang="scss" scoped>

</style>
